export default {"src":"/_next/static/media/CARBON_INVENTORY_ICON.7b9bb2d3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};